<template lang="html">
  <div class="draft-mobile">
    <router-link to="/home" class="logo">
      <img src="../assets/images/logo.png" width="60">
    </router-link>

    <h3>Pull the draft board up on your big screen to enjoy the full drafting experience</h3>

    <router-link class="back" :to="`/draft/${draft.id}/settings`" title="Back to settings">
      Back
    </router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      draft: ({ draft }) => draft.draft,
    }),
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-mobile {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: $secondary-color;
    color: $white-color;
    z-index: 100000;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: $gp * 2;
    text-align: center;
  }

  .logo {
    width: px-to-rem(120px);
    margin-bottom: $gp;
  }

  @media($medium) {
    .draft-mobile {
      display: none;
    }
  }
</style>
